import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.44412 12.0002C7.44412 9.4842 9.48371 7.44461 11.9997 7.44461C14.5156 7.44461 16.5552 9.4842 16.5552 12.0002C16.5552 14.5161 14.5156 16.5557 11.9997 16.5557C9.48371 16.5557 7.44412 14.5161 7.44412 12.0002ZM11.9997 9.88905C10.8337 9.88905 9.88856 10.8342 9.88856 12.0002C9.88856 13.1661 10.8337 14.1113 11.9997 14.1113C13.1656 14.1113 14.1108 13.1661 14.1108 12.0002C14.1108 10.8342 13.1656 9.88905 11.9997 9.88905Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12.9997 5.52039V4.3335H10.9997V5.52039C8.17982 5.952 5.95151 8.18031 5.51991 11.0002H4.33301V13.0002H5.51991C5.95151 15.82 8.17982 18.0483 10.9997 18.4799V19.6668H12.9997V18.4799C15.8195 18.0483 18.0478 15.82 18.4794 13.0002H19.6663V11.0002H18.4794C18.0478 8.18031 15.8195 5.952 12.9997 5.52039Z"}}]};

const MapAimingFilled = Vue.extend<IconProps>({
  name: 'MapAimingFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-aiming-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapAimingFilled;
